import { motion } from "framer-motion";
import { PartyPopper, Cake, Heart, Disc3, Briefcase, SlidersHorizontal, ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

const services = [
  {
    testid: "service-card-feste-paese",
    icon: PartyPopper,
    title: "Feste di Paese & Sagre",
    tag: "Energia Popolare & Grandi Piazze",
    desc: "Esperienza decennale nel far ballare intere comunità: gestione della folla, amplificazione potente e scalette travolgenti per tutte le generazioni.",
    span: "md:col-span-3",
  },
  {
    testid: "service-card-compleanni",
    icon: Cake,
    title: "Compleanni & Diciottesimi",
    tag: "Party Esclusivo & Personalizzato",
    desc: "Dal diciottesimo al cinquantesimo e oltre: playlist sartoriale con i tuoi brani preferiti, karaoke professionale e luci architetturali.",
    span: "md:col-span-3",
  },
  {
    testid: "service-card-matrimoni",
    icon: Heart,
    title: "Matrimoni d'Eccellenza",
    tag: "Ticino & Lago di Como",
    desc: "Colonna sonora impeccabile dalla cerimonia all'aperitivo fino al party scatenato, con fontane fredde ed effetti luce scenografici.",
    span: "md:col-span-2",
  },
  {
    testid: "service-card-club",
    icon: Disc3,
    title: "Club, Discoteche & Lounge",
    tag: "Beat Precision & Club Culture",
    desc: "DJ set energico, mixing fluido e tracklist all'avanguardia con residenze e serate nei club più rinomati della Svizzera.",
    span: "md:col-span-2",
  },
  {
    testid: "service-card-corporate",
    icon: Briefcase,
    title: "Eventi Aziendali & Gala",
    tag: "Corporate & Brand Launch",
    desc: "Atmosfera sofisticata per cene aziendali, lanci di prodotto e convention con microfonia wireless e regia audio impeccabile.",
    span: "md:col-span-2",
  },
  {
    testid: "service-card-producer",
    icon: SlidersHorizontal,
    title: "DJ Producer & Custom Edits",
    tag: "Studio & Produzioni Originali",
    desc: "Remix esclusivi, mashup inediti e produzioni originali per dare un'identità musicale unica al tuo evento.",
    span: "md:col-span-6",
  },
];

export default function Services() {
  const tr = useTr();
  const translated = tr("services.items", services);
  const items = services.map((s, i) => ({ ...s, ...(translated[i] || {}) }));
  return (
    <section id="servizi" className="py-24 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow={tr("services.eyebrow", "I Miei Servizi")}
          title={tr("services.title", "DJ Set di Alto Profilo")}
          accent={tr("services.accent", "Ogni evento è una produzione su misura: musica, luci ed emozioni curate nei minimi dettagli.")}
          testid="services-heading"
        />
        <div className="grid grid-cols-1 md:grid-cols-6 gap-5 px-6">
          {items.map((s, i) => (
            <motion.article
              key={s.testid}
              data-testid={s.testid}
              className={`gold-frame rounded-xl bg-[#111111] p-7 group relative ${s.span}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="flex items-start justify-between">
                <s.icon
                  size={30}
                  className="text-[#E2B857] transition-transform duration-500 group-hover:-rotate-12 group-hover:scale-110"
                  strokeWidth={1.5}
                />
                <ArrowUpRight
                  size={20}
                  className="text-[#BFA45D] opacity-0 -translate-x-1.5 translate-y-1.5 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0"
                />
              </div>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#BFA45D] mt-5">
                {s.tag}
              </p>
              <h3 className="font-display text-lg sm:text-xl font-semibold text-[#F7DE8B] mt-2">
                {s.title}
              </h3>
              <p className="text-sm text-[#E2C882]/80 leading-relaxed mt-3">{s.desc}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
